import { useState, useEffect } from "react";
import Login from "../components/Login.jsx";

import "../css/Home.css";


export default function Home() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    const [userProfile, setUserProfile] = useState({
        pfp: null,
        username: null,
        displayName: null
    });

    useEffect(() => {
       async function getProfile(){
            console.log(`Logged in? ${isLoggedIn}`);

            const response = await fetch('https://anagrams.ca/api/account/me', {
            credentials: "include"
            });

            if(!response.ok){
                setIsLoaded(true);
                return;
            }
            const data = await response.json();
            console.log(`Logged in successfuly: ${data.profile}`);
            setUserProfile(data.profile);
            setIsLoggedIn(true)
               setIsLoaded(true);
        }

         getProfile();
        
        const int1 = setInterval(getProfile, 15000)

        return () => {
            clearInterval(int1);
        };

    }, [isLoggedIn])

    if(!isLoaded){
        return (
        <>
        </>
        )
    }
    return (
        <>
            {isLoggedIn && (
                <Profile profileInfo={userProfile} />
            )}

            {!isLoggedIn && (
                <Login
                    isLoggedIn={setIsLoggedIn}
                    setProfile={setUserProfile}
                />
            )}
        </>
    );
}

function Profile({ profileInfo }) {
    console.log(profileInfo);
    return (
        <div className="profile-container">
            <div className="profile-card">
                <h2 className="profile-display-name">
                    {profileInfo.displayName || "Unknown User"}
                </h2>

                <p className="profile-username">
                    @{profileInfo.username}
                </p>
            </div>
        </div>
    );
}
